import React from 'react';
import { Hero } from '../components/Hero';
import { LocalTrust } from '../components/LocalTrust';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
export function Home() {
  return <main data-id="element-1485">
      <Hero data-id="element-1486" />
      <LocalTrust data-id="element-1487" />
      <Services data-id="element-1488" />
      <HowItWorks data-id="element-1489" />
      <FAQ data-id="element-1490" />
      <Reviews data-id="element-1491" />
    </main>;
}